import React from 'react';

function DataMindModule(props) {
    return <div>The data is being processed</div>
}

export default DataMindModule;